import * as React from 'react';

import { BetaBadge } from 'components/BetaBadge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/Tooltip';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

export const LOAD_BUILDING_MULTI_STOP_BETA_TOOLTIP =
  "Kit's AI is getting smarter and will soon autofill intermediate stops. But for now, you can manually add stops.";

export const QUICK_QUOTE_MULTI_STOP_BETA_TOOLTIP =
  'Multi-stop quoting is in beta - try it out!';

type MultiStopBetaTooltipProps = {
  children: React.ReactElement;
  message?: string;
};

// Shared Add Stop / Add Pickup / Add Drop hover affordance: Beta badge + short copy.
// Owns TooltipProvider so route forms work in unit tests without app-level providers.
export function MultiStopBetaTooltip({
  children,
  message = LOAD_BUILDING_MULTI_STOP_BETA_TOOLTIP,
}: MultiStopBetaTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          className='max-w-56 items-center justify-center'
          side='top'
          align='center'
        >
          <Flex direction='row' align='center' gap='sm'>
            <BetaBadge />
            <Typography variant='body-xs' weight='medium'>
              {message}
            </Typography>
          </Flex>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
